export enum AuthorisationType {
  DIRECTLY_AUTHORISED = 'DIRECTLY_AUTHORISED',
  AUTHORISED_REPRESENTATIVE = 'AUTHORISED_REPRESENTATIVE',
}

/** Monolith firm payload: `hasHppPermissions` as enum strings */
export const HppPermission = {
  YES: 'YES',
  NO: 'NO',
} as const;

export type HppPermissionApiValue = typeof HppPermission[keyof typeof HppPermission];

export function mapHasHppPermissionsToApi(value: boolean | null | undefined): HppPermissionApiValue {
  return value ? HppPermission.YES : HppPermission.NO;
}

export type ICreateFirmDto = {
  name: string;
  principalOrDirectorName: string | null;
  companyNumber: string | null;
  fcaNumber: string | null;
  icoNumber: string | null;
  hasHppPermissions: HppPermissionApiValue;
  authorisationType: AuthorisationType;
  website: string | null;
  emailAddress: string | null;
  phoneNumber: string | null;
  brokerIds?: string[];
};
